@for (o of options; track o; let i = $index) {
<av-option-block
  [label]="o.body"
  [active]="isActive(o)"
  [attr.data-tid]="'survey/multi/option/' + i"
>
  <input
    type="checkbox"
    name="{{ question().id }}"
    [ngModel]="o.value"
    (ngModelChange)="optionChange($event, o)"
  />
</av-option-block>
} @if (isError()) {
<div class="form-error" translate>Required</div>
}
